export default "/listings/img/type_mspar.png";